import { IResponse, Media, ProfilePicSizes } from '@eventr/common'
import { StateCreator } from 'zustand'
import { EventrGatewayAPI } from '../../data/gateway.api'
import { BoundStore } from '../../state/bound.store'

export type MediaType =
    | 'HeaderImage'
    | 'Document'
    | 'ProfilePic'
    | 'Document-Uploaded'
export const mediaTypes: MediaType[] = [
    'Document-Uploaded',
    'HeaderImage',
    'Document',
    'ProfilePic',
]
interface MediaState {}

interface MediaActions {
    uploadMedia: (
        file: File,
        type: MediaType,
        org?: string
    ) => Promise<IResponse<Media>>
}
export interface IMediaSlice extends MediaState, MediaActions {}
export const createMediaSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    IMediaSlice
> = (set, get) => ({
    uploadMedia: async (file: File, type: MediaType, org?: string) => {
        const formData = new FormData()
        const fileName = getFilePrefix(type) + file.name
        formData.append('file', file, fileName)
        const orgName = org || get().selectedOrg.name

        return EventrGatewayAPI.media.upload(formData, orgName)
    },
})

const getFilePrefix = (type: MediaType) => {
    const filePrefixes: Record<MediaType, string> = {
        HeaderImage: 'Header-Uploaded',
        ProfilePic: 'ProfilePic',
        Document: 'Document',
        'Document-Uploaded': 'Document-Uploaded',
    }

    return filePrefixes[type] || 'NoType-'
}

export const removePrefix = (url: string) => {
    const split = url.split('/')
    const fileName = split[split.length - 1]

    //if file name  starts with any of the MediaType , remove it

    for (const type in mediaTypes) {
        if (fileName.startsWith(mediaTypes[type])) {
            return fileName.slice(mediaTypes[type].length)
        }
    }
    if (fileName.startsWith('NoType-')) {
        return fileName.slice('NoType-'.length)
    }

    return fileName
}
export const getFileName = (url: string) => {
    if (!url) return ''
    const split = url.split('/')
    const name = split[split.length - 1]
    const noPrefixName = removePrefix(name)
    return noPrefixName
}

export const getMediaSizes = (image: Media): ProfilePicSizes => {
    if (!image) return null
    const sizes = image.media_details?.sizes
    if (!sizes) return null
    const resp: ProfilePicSizes = {}
    const medium = sizes.medium?.source_url
    const tiny = sizes.thumbnail?.source_url

    if (medium) {
        resp.medium = { url: medium }
    }
    if (tiny) {
        resp.tiny = { url: tiny }
    } else {
        resp.tiny = { url: image.source_url }
    }
    return resp
}
